import t from '../actions/actionTypes'

const defaultState = {
	facebook: false,
	twitter: true,
	google: false,
}

const vendorsReducer = (state = defaultState, action) => {

	switch (action.type) {
		case t.LIBRARY_LOAD: {
			const newState = {...state}
			newState[action.libraryName] = action.state
			return newState
		}
		default:
			return state
	}
}

export default vendorsReducer
